import { PageHeader, Tabs } from "antd";
import React, { Component } from "react";
import { tabStyles } from "../../../../Components/TabbedDynamicTable";
import ReporteColaborador from "./ReporteColaborador";
import ReporteCriterios from "./ReporteCriterios";
import ReporteGeneral from "./ReporteGeneral";
import ReportePrograma from "./ReportePrograma";
import ReporteProceso from "./ReporteProceso";
import { HeaderReporte, STYLES } from "./reporteCalidadStyles";

const { TabPane } = Tabs;

/**
 * Contenedor de los reportes de Calidad. Cada sub-tab es un reporte independiente con sus
 * propios filtros, gráficas y exportaciones.
 */
class ReporteCalidad extends Component {
  state = { activeTab: "general" };

  reportes = {
    general: <ReporteGeneral />,
    criterios: <ReporteCriterios />,
    programa: <ReportePrograma />,
    proceso: <ReporteProceso />,
    colaborador: <ReporteColaborador />,
  };

  tabs = [
    {
      key: "general",
      label: "General",
      eyebrow: "Control de Calidad",
      titulo: "Reporte General",
      subtitulo: "Registros de procesos ejecutados en el período",
    },
    {
      key: "criterios",
      label: "Criterios de Aceptación",
      eyebrow: "Control de Calidad",
      titulo: "Criterios de Aceptación",
      subtitulo: "Tasa de cumplimiento por criterio — los que más fallan primero",
    },
    {
      key: "programa",
      label: "Por Programa",
      eyebrow: "Control de Calidad",
      titulo: "Reporte por Programa",
      subtitulo: "Desempeño de un programa por proceso y por colaborador",
    },
    {
      key: "proceso",
      label: "Por Proceso",
      eyebrow: "Control de Calidad",
      titulo: "Reporte por Proceso",
      subtitulo:
        "Cumplimiento por punto de control y por criterio de aceptación, con evidencias de los rechazos",
    },
    {
      key: "colaborador",
      label: "Por Colaborador",
      eyebrow: "Control de Calidad",
      titulo: "Reporte por Colaborador",
      subtitulo: "Desempeño de un colaborador por programa y por proceso",
    },
  ];

  render() {
    const { embedded, history } = this.props;
    const activo = this.tabs.find((t) => t.key === this.state.activeTab) ?? this.tabs[0];

    const cuerpo = (
      <>
        <HeaderReporte
          eyebrow={activo.eyebrow}
          titulo={activo.titulo}
          subtitulo={activo.subtitulo}
        />
        <div className="cal-sep" />

        <Tabs
          activeKey={this.state.activeTab}
          onChange={(key) => this.setState({ activeTab: key })}
          className="custom-tabs no-content-border"
          tabBarStyle={{ background: "transparent", margin: 0, padding: "0 8px", minHeight: "auto" }}
        >
          {this.tabs.map((t) => (
            <TabPane
              key={t.key}
              tab={<span style={{ color: "#1a3a4a", fontWeight: 600, fontSize: 14 }}>{t.label}</span>}
            >
              {/* Sin forceRender: cada reporte consulta al abrirse su tab, no al montar la pantalla */}
              {this.reportes[t.key]}
            </TabPane>
          ))}
        </Tabs>
      </>
    );

    return (
      <>
        <style>{tabStyles}</style>
        <style>{STYLES}</style>

        {embedded ? (
          cuerpo
        ) : (
          <>
            <PageHeader
              onBack={() => history?.goBack()}
              title="Reporte de Calidad"
              subTitle="Registros de procesos"
              style={{
                border: "1px solid rgb(235, 237, 240)",
                backgroundColor: "white",
                marginBottom: 10,
              }}
            />
            <div
              style={{
                backgroundColor: "white",
                padding: 24,
                borderRadius: 20,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              {cuerpo}
            </div>
          </>
        )}
      </>
    );
  }
}

export default ReporteCalidad;
